import React from "react";

/**
 * Phone with a small watch overlay — used for Connected Devices nav.
 * Inherits color via currentColor.
 */
const PhoneWatchIcon = ({ className, size = 22, title }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    role={title ? "img" : "presentation"}
    aria-hidden={title ? undefined : true}
    aria-label={title}
  >
    {/* Phone body */}
    <path d="M7.25 1.5A2.25 2.25 0 0 0 5 3.75v14.5A2.25 2.25 0 0 0 7.25 20.5h5.5a.75.75 0 0 0 0-1.5h-5.5a.75.75 0 0 1-.75-.75V3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75V8a.75.75 0 0 0 1.5 0V3.75A2.25 2.25 0 0 0 13.25 1.5h-6z" />
    {/* Phone speaker */}
    <rect x="8.75" y="3.35" width="3.5" height="1.15" rx="0.575" />
    {/* Watch upper band */}
    <path d="M16.35 10.15c.2-.55.72-.9 1.3-.9h.7c.58 0 1.1.35 1.3.9l.35.95h-1.2l-.2-.55a.25.25 0 0 0-.23-.15h-.64a.25.25 0 0 0-.23.15l-.2.55h-1.2l.35-.95z" />
    {/* Watch lower band */}
    <path d="M16.35 21.85c.2.55.72.9 1.3.9h.7c.58 0 1.1-.35 1.3-.9l.35-.95h-1.2l-.2.55a.25.25 0 0 1-.23.15h-.64a.25.25 0 0 1-.23-.15l-.2-.55h-1.2l.35.95z" />
    {/* Watch face ring */}
    <path d="M18 11.35a4.65 4.65 0 1 0 0 9.3 4.65 4.65 0 0 0 0-9.3zm0 1.4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5z" />
    {/* Watch hands */}
    <path d="M18 13.55a.6.6 0 0 1 .6.6v1.55h1.15a.6.6 0 1 1 0 1.2H18a.6.6 0 0 1-.6-.6v-2.15a.6.6 0 0 1 .6-.6z" />
  </svg>
);

export default PhoneWatchIcon;
